import { render, staticRenderFns } from "./startExam.vue?vue&type=template&id=77a3246a&scoped=true&"
import script from "./startExam.vue?vue&type=script&lang=js&"
export * from "./startExam.vue?vue&type=script&lang=js&"
import style0 from "./startExam.vue?vue&type=style&index=0&id=77a3246a&prod&lang=css&"
import style1 from "./startExam.vue?vue&type=style&index=1&id=77a3246a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a3246a",
  null
  
)

export default component.exports